var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.data.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }